import { IzumiMessageKey } from 'izumi/IzumiMessageKey'
import { SupportedLanguage } from 'izumi/supportedLanguages'
import { vsprintf } from 'sprintf-js'

import { config } from './config'

export type TranslationsDictionary = {
  [key: string]: string
}

type TranslationsResponse = {
  data: TranslationsDictionary
  options: {
    rtl: boolean
  }
}

export function fetchTranslations(language: SupportedLanguage): Promise<TranslationsDictionary> {
  return fetch(`${config.ROOT_PATH}translations/${language}.json`)
    .then((response) => response.json())
    .then(({ data }: TranslationsResponse) => data)
}

let translations: TranslationsDictionary | null = null

export function setTranslations(translationsDictionary: TranslationsDictionary): void {
  translations = translationsDictionary
}

export function i18n(key: IzumiMessageKey, data?: string[] | number[]): string {
  if (translations === null) {
    throw new Error(
      'Translations dictionary is not set. setTranslations() needs to be called first.'
    )
  }

  const translation = translations[`wego.web.${key}`]

  if (translation && data !== undefined) {
    return vsprintf(translation, data).trim()
  }

  if (translation !== undefined) {
    return translation
  }

  return key as string
}
